module.exports = __webpack_public_path__ + "static/img/8.e0290b70.png";